var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { isNil } from '../_internal/data';
import { useParentLayout, LayoutChild } from '../Layout';
import { useCurrentBackground } from '../useCurrentBackground';
import { HeaderBarContainer } from './HeaderBar.style';
export var HeaderBar = React.forwardRef(function (props, ref) {
    var defaultBackground = useCurrentBackground();
    var children = props.children, progress = props.progress, style = props.style, small = props.small, large = props.large, sticky = props.sticky, _a = props.backgroundColor, backgroundColor = _a === void 0 ? defaultBackground : _a, rest = __rest(props, ["children", "progress", "style", "small", "large", "sticky", "backgroundColor"]);
    var parentLayout = useParentLayout();
    React.useLayoutEffect(function () {
        if (parentLayout.isInLayout) {
            return parentLayout.registerChild(LayoutChild.HeaderBar);
        }
    }, [parentLayout]);
    return (React.createElement(HeaderBarContainer, __assign({ backgroundColor: backgroundColor, ref: ref, "data-has-progress": !isNil(progress), "data-sticky": sticky, "data-is-in-layout": parentLayout.isInLayout, "data-small": small, "data-large": large, style: __assign(__assign({}, (style !== null && style !== void 0 ? style : {})), { '--header-bar-progress': progress }) }, rest), children));
});
//# sourceMappingURL=HeaderBar.js.map